import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import "../../assets/css/icon.css";
import "../../assets/css/tag-status.css";

const ALL_LEGEND_ITEMS = [
  {
    className: "tag-sent",
    label: "SPEDITO",
    description:
      "Il modulo AML è stato creato e il link è stato inviato. Il cliente non ha ancora effettuato il primo accesso.",
    routes: ["/aml/moduli-in-raccolta"],
  },
  {
    className: "tag-progress",
    label: "IN COMPILAZIONE",
    description:
      "Il modulo AML è stato aperto dal cliente ed è in fase di compilazione.",
    routes: ["/aml/moduli-in-raccolta"],
  },
  {
    className: "tag-submitted",
    label: "DA VERIFICARE",
    description:
      "Il cliente ha inviato il modulo AML compilato e firmato, ora l'admin deve verificarlo.",
    routes: ["/aml/moduli-in-raccolta"],
  },
  {
    className: "tag-rejected",
    label: "IN CORREZIONE",
    description:
      "Il modulo AML è stato rigettato dall'admin per mancanze o errori commessi nella compilazione. Il cliente ha ricevuto una mail con le istruzioni per correggere il modulo.",
    routes: ["/aml/moduli-in-raccolta"],
  },
  {
    className: "tag-expired",
    label: "SCADUTO",
    description:
      "Il modulo AML è scaduto per scadenza temporale o del documento di identità del cliente. L'admin deve rinnovarlo invitando il cliente a una nuova compilazione.",
    routes: ["/aml/moduli-scaduti"],
  },
  {
    className: "tag-ratifica",
    label: "IN RATIFICA",
    description:
      "Il modulo AML è in corso di validità ma è stato chiesto al cliente di confermarlo per un nuovo incarico.",
    routes: ["/aml/moduli-validi"],
  },
  {
    className: "tag-approved",
    label: "VALIDO",
    description:
      "Il modulo AML è stato approvato dall'admin ed è in corso di validità.",
    routes: ["/aml/moduli-validi"],
  },
  {
    className: "tag-archived",
    label: "ARCHIVIATO",
    description:
      "Il modulo AML è scaduto e l'admin ha già fatto ripartire il processo per rinnovarlo.",
    routes: ["/aml/ricerca-moduli"],
  },
];

const ModalLegendStatus = ({ onClose, title }) => {
  const location = useLocation();
  const legendItems = ALL_LEGEND_ITEMS.filter(
    (item) =>
      location.pathname === "/aml/ricerca-moduli" ||
      item.routes.includes(location.pathname),
  );

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9998,
      }}
      onClick={onClose}
    >
      <Grid
        container
        item
        xs={11}
        md={8}
        sx={{
          position: "relative",
          backgroundColor: "#fff",
          maxHeight: "90vh",
          width: { xs: "90%", sm: "80%" },
          overflowY: "auto",
          borderRadius: "16px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* ── HEADER ── */}
        <Grid
          item
          xs={12}
          style={{
            height: "60px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #c6c6c6",
            padding: "0 15px",
            gap: "10px",
          }}
        >
          <div style={{ flexShrink: 0 }}>
            <div className="icon-modal-info" />
          </div>
          <Typography
            className="color-blue-dark"
            style={{ flex: 1, minWidth: 0, fontSize: "18px", fontWeight: 600 }}
          >
            {title}
          </Typography>
          <div style={{ flexShrink: 0 }}>
            <div onClick={onClose} className="icon-modal-close" />
          </div>
        </Grid>

        {/* ── BODY ── */}
        <Grid
          container
          item
          xs={12}
          style={{ marginTop: "20px", padding: "20px", gap: "30px" }}
        >
          {legendItems.map((item) => (
            <Grid
              key={item.label}
              item
              xs={12}
              sx={{
                display: "flex",
                gap: "15px",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "center", sm: "flex-start" },
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              <div
                className={`${item.className} color-blue-dark`}
                style={{
                  padding: "6px 10px",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontWeight: 500,
                  minWidth: "150px",
                  textAlign: "center",
                }}
              >
                {item.label}
              </div>
              <Typography sx={{ fontSize: "14px", flex: 1, marginTop: "5px" }}>
                {item.description}
              </Typography>
            </Grid>
          ))}
        </Grid>

        {/* ── FOOTER ── */}
        <Grid container item xs={12} style={{ marginTop: "20px" }}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "20px",
            }}
          >
            <Button
              variant="contained"
              className="button-bg-purple"
              sx={{ display: "block", width: "140px" }}
              onClick={onClose}
            >
              <Typography
                className="color-light"
                sx={{
                  textTransform: "initial",
                  fontSize: { xs: "16px", sm: "18px" },
                  fontWeight: 500,
                }}
              >
                Chiudi
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ModalLegendStatus;
